import UnavailablesModel from 'models/UnavailablesModel';

UnavailablesStore.dispatchToken = MakeShiftEmployeeDispatcher.register(
  UnavailablesStore.dispatchCallback,
);
// Arrays from the start: the lookups below map and index these, and the self-schedule page can
// describe a block N/A entry before this store has loaded a month.
UnavailablesStore.unavailable_requests = [];
UnavailablesStore.unavailable_types = [];

UnavailablesStore.onUnavailablesHandler = function (unavailablesData, response) {
  unavailablesData.reset(response.data.unavailables);
  UnavailablesStore.unavailable_requests = response.data.unavailable_requests;
  UnavailablesStore.unavailable_types = response.data.unavailable_types;
  UnavailablesStore.trigger('unavailables:load:success');
};

UnavailablesStore.onUnavailablesError = function (error) {
  UnavailablesStore.trigger('unavailables:load:error', error);
};

UnavailablesStore.getAllUnavailables = function () {
  const data = this.present();
  return data;
};

// Approved time off only. An entry whose request is still `new` is pending, and the schedule page
// marks those with an asterisk rather than blocking the day.
UnavailablesStore.getApprovedUnavailables = function () {
  return UnavailablesStore.present().filter((entry) => {
    const request = UnavailablesStore.getAllUnavailableRequestsById(entry.unavailable_request_id);
    return !request || request.state !== 'new';
  });
};

UnavailablesStore.getAllUnavailableRequests = function () {
  const data = UnavailablesStore.unavailable_requests;
  return data;
};

UnavailablesStore.getAllUnavailableRequestsById = function (id) {
  const data = UnavailablesStore.unavailable_requests;
  let requestObj;
  data.map((request) => {
    if (parseInt(request.id, 10) === parseInt(id, 10)) {
      requestObj = request;
    }
  });
  return !requestObj ? false : requestObj;
};

UnavailablesStore.getUnavailableTypesById = function (id) {
  let unavailType = null;

  const unavailableTypes = UnavailablesStore.unavailable_types;
  for (let i = 0; i < unavailableTypes.length; i++) {
    if (unavailableTypes[i].id === id) {
      unavailType = unavailableTypes[i];
      break;
    }
  }

  return unavailType;
};

UnavailablesStore.onUnavailablesCreateHandler = function (model, response) {
  const start = model.attributes.start_date;
  const end = model.attributes.end_date;
  const range = moment().range(moment(start).toDate(), moment(end).toDate());
  const models = [];

  // need unavailable_request and unavailablemodel
  range.by('days', (momentDate) => {
    const newModel = new UnavailablesModel();
    newModel.set({ date: momentDate.format('YYYY-MM-DD') });
    newModel.set({ unavailable_request_id: model.attributes.id });
    newModel.set({ user_id: model.attributes.user_id });
  });
  UnavailablesStore.trigger(
    'unavailables:create:success',
    model.collection,
    model.attributes.id,
    response,
  );
};

UnavailablesStore.onUnavailablesCreateError = function (collection, response) {
  UnavailablesStore.trigger('unavailables:create:error', response);
};

UnavailablesStore.onCancelRequestSuccess = function (model, response) {
  var len = UnavailablesStore.models.length;
  let startDate;
  let endDate;
  for (var i = 0; i < len; i++) {
    if (typeof UnavailablesStore.models[i].attributes.unavailable_request_id === 'undefined') {
      if (UnavailablesStore.models[i].id == model.id) {
        startDate = UnavailablesStore.models[i].attributes.start_date;
        endDate = UnavailablesStore.models[i].attributes.start_date;
        UnavailablesStore.models.splice(i, 1);
        i--;
        len--;
      }
    } else if (
      UnavailablesStore.models[i].attributes.unavailable_request_id
      == model.attributes.unavailable_request_id
    ) {
      var data = UnavailablesStore.getAllUnavailableRequestsById(
        UnavailablesStore.models[i].attributes.unavailable_request_id,
      );
      startDate = data.start_date;
      endDate = data.end_date;
      UnavailablesStore.models.splice(i, 1);
      i--;
      len--;
    }
  }
  if (Utils.isNotDefined(startDate)) {
    var len = UnavailablesStore.unavailable_requests.length;
    for (var i = 0; i < len; i++) {
      if (UnavailablesStore.unavailable_requests[i].id == model.attributes.unavailable_request_id) {
        var data = UnavailablesStore.unavailable_requests[i];
        startDate = data.start_date;
        endDate = data.end_date;
        UnavailablesStore.unavailable_requests.splice(i, 1);
        i--;
        len--;
      }
    }
  }
  UnavailablesStore.trigger(
    'unavailables:cancel:success',
    model.attributes,
    response,
    startDate,
    endDate,
  );
};

UnavailablesStore.onCancelRequestError = function (collection, response) {
  UnavailablesStore.trigger('unavailables:cancel:error', response);
};
